module.exports = __webpack_public_path__ + "img/wireSpool.0ba9271b.png";